module.exports = __webpack_public_path__ + "img/waki.98b28ff5.jpg";